import React, { FormEvent, useCallback, useEffect, useState } from 'react'
import { get } from 'lodash'
import toast from 'react-hot-toast'
import { useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import api from '../../services/axios'
import { StoreState } from '../../store'
import swal from 'sweetalert'
import { Button } from '@mui/material'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import Slide from '@mui/material/Slide'
import { TransitionProps } from '@mui/material/transitions'
import { Back, Container, LinkContent, Page } from './styles'
import { frequenciaCobranca } from '../../utils/frequenciaCobranca'
import { cnpjCpfMask } from '../../utils/masks'
import { useDispatch } from 'react-redux'
import { selectedMenu } from '../../store/modules/menu/actions'
import { useBancos } from '../../hooks/bancos'
import { TbArrowBackUp } from 'react-icons/tb'

import TableParcelas from '../../components/tableParcelas'
import dayjs from '../../libs/dayjs'

import { Checkbox, InputLabel, MenuItem, Select } from '@mui/material'
import { arranjosPrincipais, getIcon } from '../../utils/arranjos'
import { useCredenciadoras } from '../../hooks/credenciadoras'
import { useForm, Controller, SubmitHandler } from 'react-hook-form'

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>
    },
    ref: React.Ref<unknown>
) {
    return <Slide direction="up" ref={ref} {...props} />
})

interface Inputs {
    credenciadora: string
    bandeiras: string[]
}

const LinkPagar: React.FC = () => {
    const { cnpj_cpf } = useSelector((state: StoreState) => state.auth.user)
    const { suasCredenciadoras } = useCredenciadoras()
    const { bancos } = useBancos()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { id } = useParams()
    const [billingLink, setBillingLink] = useState({} as any)
    const [confirmLink, setConfirmLink] = useState(false)
    const [declineLink, setDeclineLink] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const {
        control,
        handleSubmit,
        formState: { errors },
        setValue,
    } = useForm<Inputs>({
        defaultValues: {
            bandeiras: ['MCC', 'ECC', 'VCC', 'HCC', 'ACC'],
        },
    })

    useEffect(() => {
        if (billingLink.tipoLink === 2) {
            setValue('credenciadora', Object.keys(suasCredenciadoras)[0])
        }
    }, [setValue, suasCredenciadoras, billingLink.tipoLink])

    const getPaymentLink = useCallback(async () => {
        try {
            dispatch(
                selectedMenu({
                    mainMenu: '',
                    subMenu: '',
                    currentLink: '/cobrancas',
                })
            )
            const { data } = await api.get(`/link/${cnpj_cpf}/${id}`)
            setBillingLink(data)
        } catch (error: any) {
            const erro = get(error, 'response.data.error', '')
            const status = get(error, 'response.status', '')

            if (status === 400) {
                navigate('/cobrancas')
                toast.error(erro)
            }
        }
    }, [id, cnpj_cpf, navigate, dispatch])

    useEffect(() => {
        // pegar dados do link de pagamento
        getPaymentLink()
    }, [getPaymentLink])

    const handleAccept: SubmitHandler<Inputs> = async (inputs) => {
        setConfirmLink(false)
        setIsLoading(true)
        try {
            const obj: any = {}
            if (billingLink?.tipoLink === 2) {
                obj.credenciadora = inputs.credenciadora
                obj.bandeiras = inputs.bandeiras
            }
            const { data } = await api.post('/cobranca/aceitar', {
                cnpj_cpf,
                identificadorCobranca: id,
                ...obj,
            })
            const title =
                billingLink?.tipoLink === 0
                    ? 'Pagamento concluído com sucesso!'
                    : 'Recorrência criada com sucesso!'
            const text = billingLink?.tipoLink === 0 ? '' : 'recorrente'
            swal({
                title: title,
                text: `Você já faz parte do futuro 🚀`,
                icon: 'success',
            })
            setIsLoading(false)

            navigate('/cobrancas?a=true')
        } catch (error) {
            setIsLoading(false)

            const messageError = get(error, 'response.data.error', '')
            swal({
                title: 'Erro ao pagar cobrança',
                text: `${messageError}`,
                icon: 'error',
            })
        }
    }

    // const handleAccept = async (e: FormEvent) => {
    //     e.preventDefault()

    // }

    async function handleDecline(e: FormEvent) {
        e.preventDefault()
        setIsLoading(true)

        try {
            const { data } = await api.put('/cobranca/recusar', {
                cnpj_cpf,
                identificadorCobranca: id,
            })
            setDeclineLink(false)
            swal({
                title: 'Sucesso!',
                text: `Cobrança recusada com sucesso.`,
                icon: 'success',
            })
            setIsLoading(false)

            navigate('/cobrancas?a=true')
        } catch (error) {
            setIsLoading(false)

            setDeclineLink(false)
            // const messageError = get(error, 'response.data.error', '')
            swal({
                title: 'Erro ao recusar cobrança',
                text: `Não foi possível recusar a cobrança.`,
                icon: 'error',
            })
        }
    }

    function billingLinkInfo() {
        if (
            billingLink.tipoLink === 0 &&
            Number(billingLink.quantParcelas) === 1
        ) {
            return (
                <>
                    <p>
                        <strong className="canal">Forma de pagamento: </strong>{' '}
                        À vista
                    </p>
                </>
            )
        }

        if (
            billingLink.tipoLink === 0 &&
            Number(billingLink.quantParcelas) > 1
        ) {
            return (
                <>
                    <p>
                        <strong className="canal">Forma de pagamento: </strong>{' '}
                        Parcelado
                    </p>
                    <p>
                        <strong className="canal">Número de parcelas: </strong>{' '}
                        {billingLink.quantParcelas} parcelas
                    </p>
                </>
            )
        }

        if (billingLink.tipoLink === 1) {
            return (
                <>
                    <p>
                        <strong className="canal">Forma de pagamento: </strong>{' '}
                        Recorrente
                    </p>
                    <p>
                        <strong className="canal">
                            Frequência da cobrança:{' '}
                        </strong>{' '}
                        {
                            frequenciaCobranca[
                                Number(
                                    billingLink.billingFrequency
                                ) as keyof typeof frequenciaCobranca
                            ]
                        }
                    </p>
                </>
            )
        }
    }
    return (
        <Page>
            <Back
                onClick={() => {
                    navigate('/cobrancas?a=true')
                    dispatch(
                        selectedMenu({
                            mainMenu: 'Cobranças',
                            subMenu: '',
                            currentLink: '/cobrancas',
                        })
                    )
                }}
            >
                <TbArrowBackUp size={33} color="#272D2D" />
            </Back>
            <Container>
                <h2>Pagar cobrança</h2>
                <LinkContent>
                    <div className="input-group">
                        <h3>Valor a pagar</h3>
                        <div className="wrapper">
                            <p>
                                {Number(billingLink.valor).toLocaleString(
                                    'pt-br',
                                    { style: 'currency', currency: 'BRL' }
                                )}
                            </p>
                        </div>
                    </div>

                    <div className="input-group">
                        <div className="wrapper info">
                            {billingLinkInfo()}
                            <p>
                                <strong className="canal">
                                    Canal de origem:{' '}
                                </strong>
                                {billingLink.canal}
                            </p>
                            {/* <p><strong className='canal'>Duração: </strong>{recurrence.duracao} meses</p> */}
                        </div>
                    </div>

                    <div className="input-group">
                        <h3>Dados do recebedor</h3>
                        <div className="receiver">
                            <div className="wrapper">
                                <strong>Para: </strong>
                                <p>{billingLink.nomeTitular}</p>
                            </div>
                            <div className="wrapper">
                                <p>
                                    <strong>Cpf/Cnpj: </strong>{' '}
                                    {cnpjCpfMask(
                                        billingLink.numeroDocumentoTitular || ''
                                    )}
                                </p>
                            </div>
                        </div>
                        <h4>Domicílio bancário: </h4>
                        <div className="flex">
                            <div className="wrapper">
                                <p>Banco: {bancos[billingLink.compe]}</p>
                            </div>
                            <div className="wrapper">
                                <p>Agência: {billingLink.agencia}</p>
                            </div>
                            <div className="wrapper">
                                <p>
                                    Número da conta: {billingLink.numeroConta}
                                </p>
                            </div>
                        </div>
                        <div className="wrapper">
                            <p>Tipo de conta: {billingLink.tipoConta}</p>
                        </div>
                    </div>

                    {/* <h4>Contato: </h4>
                <div className="flex">
                    <div className="wrapper">
                        <p><span>Email: </span>{contract.emailRecebedor}</p>
                    </div>
                    <div className="wrapper">
                        <p><span>Telefone: </span>{foneMask(contract.foneRecebedor)}</p>
                    </div>
                </div> */}

                    <div className="input-group">
                        <h3>Dados do pagador</h3>
                        <div className="wrapper">
                            <strong>De: </strong>
                            <p>{billingLink.nomePagador}</p>
                        </div>
                        <div className="wrapper">
                            <p>
                                <strong>Cpf/Cnpj: </strong>
                                {cnpjCpfMask(billingLink.cnpjPagador || '')}
                            </p>
                        </div>
                    </div>

                    <div className="input-group">
                        <div className="wrapper details">
                            <p>
                                Data e hora da criação:{' '}
                                {dayjs(billingLink.createdAt).format(
                                    'DD/MM/YYYY - HH:mm:ss'
                                )}
                            </p>
                            <p>Observação: {billingLink.observacao || 'n/a'}</p>
                        </div>
                    </div>
                </LinkContent>
                <div className="actions">
                    <Button
                        type="button"
                        onClick={() => setDeclineLink(true)}
                        variant="outlined"
                        disabled={isLoading}
                        color="error"
                    >
                        Recusar
                    </Button>

                    <Button
                        type="button"
                        disabled={isLoading}
                        onClick={() => setConfirmLink(true)}
                        variant="contained"
                    >
                        Pagar
                    </Button>
                </div>

                <Dialog
                    open={confirmLink}
                    TransitionComponent={Transition}
                    keepMounted
                    onClose={() => setConfirmLink(false)}
                    aria-describedby="alert-dialog-slide-description"
                >
                    <DialogTitle>Pagar cobrança</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-slide-description">
                            Tem certeza que deseja pagar esta cobrança?
                        </DialogContentText>
                        <form
                            onSubmit={handleSubmit(handleAccept)}
                            id="form-link"
                        >
                            {billingLink.tipoLink === 2 && (
                                <div className="mt-4 flex flex-col md:flex-row md:items-start gap-4">
                                    <Controller
                                        control={control}
                                        name="bandeiras"
                                        rules={{
                                            required: true,
                                        }}
                                        render={({ field }) => (
                                            <div className="space-y-2">
                                                <label
                                                    id="demo-multiple-chip-label"
                                                    className="text-sm text-gray-700 block"
                                                >
                                                    Com quais bandeiras você
                                                    gostaria de pagar?
                                                </label>
                                                <Select
                                                    labelId="demo-multiple-chip-label"
                                                    id="demo-multiple-chip"
                                                    sx={{
                                                        height: '34px',
                                                        minWidth: '200px',
                                                        borderRadius: '0.5rem',
                                                        borderColor: '#D1D5DB',
                                                    }}
                                                    className=" bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent mt-1"
                                                    multiple
                                                    value={field.value}
                                                    onChange={(event) => {
                                                        const value =
                                                            event.target.value
                                                        const bandeiras =
                                                            typeof value ===
                                                            'string'
                                                                ? value.split(
                                                                      ','
                                                                  )
                                                                : value

                                                        field.onChange(
                                                            bandeiras
                                                        )
                                                    }}
                                                    ref={field.ref}
                                                    renderValue={(selected) => {
                                                        return 'Bandeira'
                                                    }}
                                                >
                                                    {Object.entries(
                                                        arranjosPrincipais
                                                    ).map(([chave, valor]) => (
                                                        <MenuItem
                                                            key={chave}
                                                            value={chave}
                                                        >
                                                            <Checkbox
                                                                checked={
                                                                    field.value?.indexOf(
                                                                        chave
                                                                    ) > -1
                                                                }
                                                            />

                                                            <img
                                                                height={35}
                                                                width={40}
                                                                src={getIcon(
                                                                    chave
                                                                )}
                                                                alt="Icon bandeira cartão"
                                                            />
                                                        </MenuItem>
                                                    ))}
                                                </Select>

                                                {errors.bandeiras &&
                                                    errors.bandeiras.type ===
                                                        'required' && (
                                                        <span className="text-red-500 text-sm block">
                                                            Selecione pelo menos
                                                            uma bandeira
                                                        </span>
                                                    )}
                                            </div>
                                        )}
                                    />
                                    <Controller
                                        control={control}
                                        name="credenciadora"
                                        rules={{
                                            required: true,
                                        }}
                                        render={({ field }) => (
                                            <div className="space-y-2">
                                                <label
                                                    htmlFor="credenciadora"
                                                    className="text-sm text-gray-700 block"
                                                >
                                                    Com qual credenciadora você
                                                    gostaria de pagar?
                                                </label>
                                                <select
                                                    id="credenciadora"
                                                    value={field.value}
                                                    name="credenciadora"
                                                    onChange={(e) =>
                                                        field.onChange(
                                                            e.target.value
                                                        )
                                                    }
                                                    ref={field.ref}
                                                    className="cursor-pointer rounded-lg w-full flex-1 border border-gray-300 py-1 px-2 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
                                                >
                                                    {Object.entries(
                                                        suasCredenciadoras
                                                    ).map(([chave, valor]) => {
                                                        return (
                                                            <option
                                                                key={chave}
                                                                value={chave}
                                                            >
                                                                {valor}
                                                            </option>
                                                        )
                                                    })}
                                                </select>
                                                {errors.credenciadora &&
                                                    errors.credenciadora
                                                        .type ===
                                                        'required' && (
                                                        <span className="text-red-500 text-sm">
                                                            Selecione uma
                                                            credenciadora
                                                        </span>
                                                    )}
                                            </div>
                                        )}
                                    />
                                </div>
                            )}
                        </form>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setConfirmLink(false)}>
                            Cancelar
                        </Button>
                        <Button type="submit" form="form-link">
                            Sim, pagar
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={declineLink}
                    TransitionComponent={Transition}
                    keepMounted
                    onClose={() => setDeclineLink(false)}
                    aria-describedby="alert-dialog-slide-description"
                >
                    <DialogTitle>Recusar cobrança</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-slide-description">
                            Tem certeza que deseja recusar esta cobrança?
                        </DialogContentText>
                        <form
                            onSubmit={handleDecline}
                            id="form-link-decline"
                        ></form>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setDeclineLink(false)}>
                            Cancelar
                        </Button>
                        <Button type="submit" form="form-link-decline">
                            Sim, recusar
                        </Button>
                    </DialogActions>
                </Dialog>
            </Container>
            <div className="max-w-lg">
                {billingLink.tipoLink === 0 && (
                    <TableParcelas
                        data_Liquidacao={billingLink?.dataLiquidacao}
                        valueLink={Number(billingLink?.valor)}
                        quantParcelas={Number(billingLink?.quantParcelas || 0)}
                    />
                )}
            </div>
        </Page>
    )
}

export default LinkPagar
